// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nQAr","icon":"styles_icon__1R9lE"};